import { render } from "./ItemGeneric.vue?vue&type=template&id=169ef2bf"
import script from "./ItemGeneric.vue?vue&type=script&lang=js"
export * from "./ItemGeneric.vue?vue&type=script&lang=js"
script.render = render

export default script